import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'bb-how-it-works-nav',
  templateUrl: './how-it-works-nav.component.html',
  styleUrls: ['./how-it-works-nav.component.scss'],
})
export class HowItWorksNavComponent {
  slug: string;

  constructor(private route: ActivatedRoute) {
    this.slug = this.route.root.firstChild.firstChild.routeConfig.path;
  }
}
